module.exports = __webpack_public_path__ + "img/45e84c530fb5631957a9d00cea89f559.png";